var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#00B081"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7616 16.7702C36.1252 16.3123 36.0663 15.6318 35.6299 15.2502C35.1935 14.8686 34.5449 14.9305 34.1812 15.3884L26.7883 24.6969C25.3033 26.5667 24.2586 27.878 23.3525 28.7365C22.4676 29.575 21.8568 29.8415 21.2571 29.8415C20.6575 29.8415 20.0467 29.575 19.1618 28.7365C18.2557 27.878 17.211 26.5667 15.726 24.6969L13.8188 22.2955C13.4551 21.8376 12.8065 21.7757 12.3701 22.1573C11.9337 22.5389 11.8748 23.2194 12.2384 23.6773L14.1986 26.1454C15.6184 27.9331 16.7554 29.3648 17.7831 30.3385C18.8446 31.3443 19.9298 32 21.2571 32C22.5845 32 23.6697 31.3443 24.7312 30.3385C25.7589 29.3648 26.8959 27.9331 28.3157 26.1454L35.7616 16.7702Z",
    fill: "#F7F7FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.25e5fdcc38f4e83735c2ae8328b8209b.svg";
export { ForwardRef as ReactComponent };